import { Directive, OnChanges, Input, SimpleChanges } from '@angular/core';
import { LnpService } from './lnp.service';
import { LnpComponentLoadedEvent } from '@interfaces/lnp-component-loaded-event.model';

@Directive({
  selector: '[appLnp]',
})
export class LnpDirective implements OnChanges {
  @Input() lnpComponentName: string;
  @Input() lnpMarkLoadedOn: any;

  constructor(private lnpService: LnpService) {}

  ngOnChanges(changes: SimpleChanges) {
    this.lnpService.triggerComponentLoaded(
      new LnpComponentLoadedEvent({
        component: this.lnpComponentName,
        data: changes.lnpMarkLoadedOn?.currentValue,
      })
    );
  }
}
